const setStream = (res) => {
    const str = res.headers['content-disposition'].match(/filename="(\S*)"/)[1];
    const name = decodeURIComponent(str)

    let binaryData = [];
    binaryData.push(res.data);
    let fileName = name 
    let link = document.createElement('a')
    link.download = fileName
    link.style.display = 'none'

    link.href = window.URL.createObjectURL(new Blob(binaryData))

    document.body.appendChild(link)
    link.click()
    URL.revokeObjectURL(link.href) 
    document.body.removeChild(link)
}

export default setStream